export default __webpack_public_path__ + "static/media/MaybeSomeday.232a9205.mp3";